<template>
    <section class="o-bk-box box-sh bg-white is-rounded mt-4">
        <div class="o-bk-box__title d-flex align-items-center">
            <span class="icon-luggage is-square-icon is-rounded bg-sec-light-hover cl-sec-l"></span>
            <h3 class="c-ttl c-ttl--mdp ml-3">Extra luggage <span
                class="cl-sec-l fw-r ml-1 fs-16">{{ currency(price) }} each</span></h3>
        </div>

        <div class="cl-dark">
            <!--p class="p-3 mt-3 mb-4 is-rounded bg-suc cl-sec">
                Completa le informazioni del passeggero come indicati sui documenti di viaggio
                che utilizzerai.
            </p-->

            <p class="my-4 fs-14 lh-xl">
                <info-icon />
                You have {{luggageInfo.free}} check-in luggage included in your ticket. Should you require extra luggage please book below.<br><br>
                Extra luggage booked is NON REFUNDABLE.<br><br>
                Apart from check-in luggage, all passengers are entitled to carry one hand luggage of a set size and weight. Full luggage / baggage allowance can be viewed in the info section at the bottom of this page. 
            </p>

            <div class="luggage-items" v-if="luggage.length">
                <div class="o-bk-form-row" v-for="luggageItem in luggage" v-bind:key="luggageItem.passenger">
                    <div class="o-bk-form-row__item is-md">
                        <div class="form-group">
                            <label class="mb-1 fw-r d-block">Passenger</label>

                            <input class="form-control" :value="getPassengerName(luggageItem.passenger)" disabled>
                        </div>
                    </div>

                    <div class="o-bk-form-row__item is-md">
                        <div class="form-group">
                            <label class="mb-1 fw-r d-block">Quantity</label>

                            <select
                                required
                                class="form-control custom-select"
                                :value="luggageItem.quantity"
                                @change="updateLuggageQuantity(luggageItem.passenger, $event.target.value)">
                                <option :value="i" v-for="i in 3" v-bind:key="i">{{ i }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="o-bk-form-row__item is-md">
                        <div class="form-group text-right">
                            <label class="mb-1 fw-r d-none d-md-block">&nbsp;</label>
                            <button
                                class="btn btn-white-alt-sec-l is-smaller bg-white txt-init"
                                name="remove-luggage"
                                type="button"
                                @click="removeLuggage(luggageItem.passenger)">
                                Remove luggage
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <form class="o-bk-form-row" @submit="addLuggage">
                <div class="o-bk-form-row__item is-md">
                    <div class="form-group">
                        <label class="mb-1 fw-r d-block">Select passenger</label>

                        <select class="form-control custom-select" v-model="addForm.passenger" required>
                            <option></option>
                            <option
                                v-for="option in passengerOptions"
                                v-bind:key="option.key"
                                :disabled="option.disabled"
                                :value="option.key"
                            >{{ option.label }}</option>
                        </select>
                    </div>
                </div>

                <div class="o-bk-form-row__item is-md">
                    <div class="form-group">
                        <label class="mb-1 fw-r d-block">Quantity</label>

                        <select class="form-control custom-select" v-model="addForm.quantity" required>
                            <option :value="i" v-for="i in 3" v-bind:key="i">{{ i }}</option>
                        </select>
                    </div>
                </div>

                <div class="o-bk-form-row__item is-md">
                    <div class="form-group text-right">
                        <label class="mb-1 fw-r d-none d-md-block">&nbsp;</label>
                        <button class="btn btn-white-alt-sec-l is-smaller bg-white txt-init" type="submit">Add luggage</button>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import InfoIcon from '../components/InfoIcon.vue'
export default {
    components: { InfoIcon },
    data() {
        return {
            addForm: {
                passenger: null,
                quantity: null,
            },
        }
    },
    computed: {
        ...mapState('booking', [
            'passengers',
            'luggage',
            'prices',
            'ticket',
            'luggageInfo',
        ]),
        passengerOptions() {
            return this.passengers.filter(passenger => passenger.category != 'inf').map((passenger, index) => {
                return {
                    key: index,
                    label: passenger.name+' '+passenger.surname,
                    disabled: this.luggage.find(luggage => luggage.passenger == index),
                }
            })
        },
        price() {
            return parseFloat(this.prices.luggage.price.out) + (this.ticket != 'oneway' ? parseFloat(this.prices.luggage.price.ret) : 0)
        }
    },
    methods: {
        ...mapActions('booking', [
            'getQuote'
        ]),
        getPassengerName(passengerIndex) {
            let passenger = this.passengers[passengerIndex]
            return passenger.name+' '+passenger.surname
        },
        addLuggage(e) {
            e.preventDefault()
            this.$store.commit('booking/addLuggage', {
                passenger: parseInt(this.addForm.passenger),
                quantity: parseInt(this.addForm.quantity),
            })
            this.addForm.passenger = null
            this.addForm.quantity = null
            this.getQuote()

            this.track({
                event: 'add_luggage'
            })
        },
        updateLuggageQuantity(passenger, quantity) {
            this.$store.commit('booking/updateLuggageQuantity', {
                passenger: parseInt(passenger),
                quantity: parseInt(quantity),
            })
            this.getQuote()
        },
        removeLuggage(passenger) {
            this.$store.commit('booking/removeLuggage', {
                passenger: parseInt(passenger)
            })
            this.getQuote()

            this.track({
                event: 'remove_luggage'
            })
        },
    }
}
</script>